const calcCost = (priceObj, columnName, laborCost, listPrice) => {
  const retail = priceObj[columnName + "_retail"];
  const labor = priceObj[columnName + "_labor"]; // man hours
  const materials = priceObj[columnName + "_materials"];

  const tax = retail * 0.0825 || 0;
  const laborTotalCost = laborCost * labor;
  const totalCost = materials + tax + laborTotalCost;
  const profit = listPrice - totalCost;

  return { tax, laborTotalCost, totalCost, profit };
};

const calcTotalCost = (
  cost_retail,
  cost_materials,
  cost_labor,
  laborCost,
  price
) => {
  const tax = cost_retail * 0.0825 || 0;
  const laborTotalCost = cost_labor * laborCost;
  const totalCost = cost_materials + tax + laborTotalCost;
  const profit = price - totalCost;

  return { tax, laborTotalCost, totalCost, profit };
};

export { calcCost, calcTotalCost };
